<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :buildingActive="'active'"
    :serviceDescription="serviceDescription"
  ></service-view>
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "building",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name:
          "services/Building_bricklaying_plastering/IMG-20180209-WA0012.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name:
          "services/Building_bricklaying_plastering/IMG-20180209-WA0013.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name:
          "services/Building_bricklaying_plastering/IMG-20180209-WA0017.jpg",
        title: "Domestic Construction",
        location: "Zambia"
      },
      {
        name:
          "services/Building_bricklaying_plastering/IMG-20180209-WA0020.jpg",
        title: "Laying foundation",
        location: "Zambia"
      },
      {
        name: "services/Building_bricklaying_plastering/building1.jpg",
        title: "Laying foundation",
        location: "Zambia"
      },
      {
        name: "services/Building_bricklaying_plastering/building2.jpg",
        title: "Laying foundation",
        location: "Zambia"
      },
      {
        name: "services/Building_bricklaying_plastering/building3.jpg",
        title: "Laying foundation",
        location: "Zambia"
      }
    ],
    serviceTitle: "Building",
    serviceDescription:
      "We offer bricklaying, plastering, rhinolite wall skimming, dry walling."
  })
};
</script>
